import { QRCodeSVG } from "qrcode.react";

const MyQRCode = (props:{url:string}) => {
      // Aquí pones la URL a la que deseas redirigir
    return (
        <div style = {{margin:'10px', display: 'flex', justifyContent:'center'}}>
            <QRCodeSVG value={props.url} />
        </div>
    );
};

export default MyQRCode;
